import { SupportedMessageFormats } from "../../../Contracts";
const formats = {
    [SupportedMessageFormats["jsonrpc2.0"]]: payload => {
        return {
            id: payload.id,
            result: payload.result,
            error: payload.error
        };
    }
};
export function ResponseFormatter(type, payload) {
    return formats[type](payload);
}
//# sourceMappingURL=ResponseFormatter.js.map